// *******************
// *******************
// FILE AUTO GENERATO! n// *******************
// *******************

export const _dispositivoTypeUtilsData = {
  "Macchinario": {
    "label": {
      "it": "Macchinario",
      "de": "Maschine",
      "en": "Machine"
    },
    "EntityName": "Macchinario"
  },
  "Unknown": {
    "label": {
      "it": "Sconosciuto",
      "de": "Unbekannt",
      "en": "Unknown"
    },
    "EntityName": "Unknown"
  },
  "Sensore": {
    "label": {
      "it": "Sensore",
      "de": "Sensor",
      "en": "Sensor"
    },
    "EntityName": "Sensore"
  }
} as const